import currencies from "../data/currency_data.json"

// This holds all currencies to select (and i proper format for select boxes)
export const currencies_obj = currencies.map(currency => ({
    value: currency.Code,
    label: `${currency.CountryName} - ${currency.Currency} (${currency.Symbol})`
}));

